import { render, staticRenderFns } from "./tizhibianshi-list.vue?vue&type=template&id=78ea9fae&scoped=true&"
import script from "./tizhibianshi-list.vue?vue&type=script&lang=ts&"
export * from "./tizhibianshi-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ea9fae",
  null
  
)

export default component.exports